import { render, staticRenderFns } from "./DeletedPhoto.vue?vue&type=template&id=85311f7e&scoped=true&"
import script from "./DeletedPhoto.vue?vue&type=script&lang=js&"
export * from "./DeletedPhoto.vue?vue&type=script&lang=js&"
import style0 from "./DeletedPhoto.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DeletedPhoto.vue?vue&type=style&index=1&id=85311f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85311f7e",
  null
  
)

export default component.exports